import Point from './Point';

export default class MathUtils {
	public static distance = (p1:Point, p2:Point):number => {
		let dx = p1.x - p2.x;
		let dy = p1.y - p2.y;
		return Math.sqrt(dx * dx + dy * dy);
	};

	public static triangleArea = (d1:number, d2:number, d3:number):number => {
		let s = (d1 + d2 + d3) / 2;
		return Math.sqrt(s * (s - d1) * (s - d2) * (s - d3));
	};
}